import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme.css';

// Compatibilidade com links antigos em `/#/rota` (o site já usou HashRouter,
// e versões já publicadas do app têm esses links embutidos). Reescrevemos para
// o caminho limpo antes de montar o BrowserRouter.
if (window.location.hash.startsWith('#/')) {
  const path = window.location.hash.slice(1); // remove só o '#'
  window.history.replaceState(null, '', path + window.location.search);
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Elemento #root não encontrado em index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
